import { useCallback, useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import styles from "./FreeTextView.module.css";
import { useTranslation } from "react-i18next";
import RichTextEditor from "src/components/tiptap/RichTextEditor";
import { getHtmlStringForTipTap } from "src/utils/HTMLUtils";

const FreeTextViewBase = () => {
    const { t } = useTranslation();
    const { assemblyStore, agendaitemStore } = useContext(RootStoreContext);
    const [headerText, setHeaderText] = useState<string>(assemblyStore.currentAssembly?.header ?? "");
    const [footerText, setFooterText] = useState<string>(assemblyStore.currentAssembly?.footer ?? "");

    const onEditorCreate = useCallback(({ editor }: { editor: { commands: { focus: () => void } } }) => {
        editor.commands.focus();
    }, []);

    const onChangeFreeText = useCallback((update: { editor: any }) => {
        const value = update.editor.getHTML();
        if (assemblyStore.isFreetextHeaderExpanded) {
            setHeaderText(value);
            runInAction(() => {
                if (assemblyStore.currentAssembly) {
                    assemblyStore.currentAssembly.header = value;
                    agendaitemStore.agendaItemsHaveChanged = true;
                }
            });
        } else if (assemblyStore.isFreetextFooterExpanded) {
            setFooterText(value);
            runInAction(() => {
                if (assemblyStore.currentAssembly) {
                    assemblyStore.currentAssembly.footer = value;
                    agendaitemStore.agendaItemsHaveChanged = true;
                }
            });
        }
    }, []);

    return (
        <div className={styles.FreeTextView}>
            <RichTextEditor
                className={styles.FreeTextInput}
                key={assemblyStore.isFreetextHeaderExpanded ? "header" : "footer"}
                enableContentCheck={true}
                content={getHtmlStringForTipTap(
                    assemblyStore.isFreetextHeaderExpanded
                        ? headerText
                        : assemblyStore.isFreetextFooterExpanded
                          ? footerText
                          : ""
                )}
                onEditorCreate={onEditorCreate}
                onContentUpdate={onChangeFreeText}
                disabled={assemblyStore.isAssemblyReadOnly}
                placeholder={t("screens.assemblies.agenda.freetext_placeholder").toString()}
            />
        </div>
    );
};

export const FreeTextView = Sentry.withProfiler(observer(FreeTextViewBase));
